module.exports = __webpack_public_path__ + "38f89351fb6ff8377e6ba0151ac6df99.MP3";